exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Perm-Life-Insurance .sectionHeader{border-radius:5px;font-family:\"Century Gothic\",\"Tahoma\",\"Gill Sans\";font-size:19px;padding:5px;background-color:#f3f3f3;color:#2e7ab5;margin-bottom:8px}.Perm-Life-Insurance .case-text{margin-left:29px;color:#000;font-size:12px;font-family:\"Open Sans\",\"Tahoma\",\"Verdana\",\"Arial\",\"sans-serif\";line-height:17px;margin-top:-18px}.Perm-Life-Insurance .radio-grp .MuiFormControlLabel-root .MuiFormControlLabel-label{font-weight:600}.Perm-Life-Insurance .validation-message{color:#f44336;margin:0;font-size:.75rem;margin-top:3px;text-align:left;font-family:\"museo-sans\",\"Helvetica\",\"Arial\",sans-serif;font-weight:400;line-height:1.66}.Perm-Life-Insurance .select-input-center-option select{padding:19px 12px 18px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Product/PermLifeInsurance/PermLifeInsurance.scss
// module id = 7705
// module chunks = 101